import { Controller } from "@hotwired/stimulus";
import { calculateMeasure, formatComputed, formatInput, toDisplay } from "../reconstitution.js";

export default class extends Controller {
  static targets = [
    "inputTemplate",
    "input",
    "inputs",
    "optionTemplate",
    "option",
    "options",
    "water",
    "draw",
    "vialWarning",
  ];
  static values = { volumes: Array };

  update(state, result, fields) {
    this.inputTargets.forEach((input) => input.remove());
    this.optionTargets.forEach((option) => option.remove());
    this.element.hidden = state.entryMode !== "amount" || !result.ready;
    this.vialWarningTarget.hidden = !result.exceedsVial;
    if (this.element.hidden) return;

    this.waterTarget.textContent = `${formatInput(state.volumeMl)} mL`;
    this.drawTarget.textContent = drawText(result);
    fields.forEach((field, index) => {
      const input = this.inputTemplateTarget.content.firstElementChild.cloneNode(true);
      fillFields(input, {
        label: fields.length === 1 ? "Your vial" : `Compound ${index + 1}`,
        vial: `${field.quantityText} ${field.quantity}`,
        dose: `${field.doseText} ${field.dose}`,
      });
      this.inputsTarget.append(input);
    });

    const target = state.target.kind === "volume" ? { kind: "total", value: result.totalDose } : state.target;
    this.volumesValue.forEach((volumeMl) => {
      const example = calculateMeasure({ ...state, volumeMl, target });
      if (!example.ready) return;

      const option = this.optionTemplateTarget.content.firstElementChild.cloneNode(true);
      const current = volumeMl === state.volumeMl;
      option.dataset.current = String(current);
      fillFields(option, { water: `${formatInput(volumeMl)} mL`, draw: drawText(example) });
      option.querySelector('[data-comparison-field="current"]').hidden = !current;
      option.querySelector('[data-comparison-field="warning"]').hidden = !example.exceedsSyringe;
      this.optionsTarget.append(option);
    });
  }
}

function fillFields(element, values) {
  Object.entries(values).forEach(([name, value]) => {
    element.querySelector(`[data-comparison-field="${name}"]`).textContent = value;
  });
}

function drawText(result) {
  const units = formatComputed(toDisplay(result.volumeMl, "units"), { grouping: true });
  return `${units} ${units === "1" ? "unit" : "units"} · ${formatComputed(result.volumeMl, { grouping: true })} mL`;
}
